import { render, staticRenderFns } from "./SeyirLocationLogsForVehicle.vue?vue&type=template&id=363a6519&"
import script from "./SeyirLocationLogsForVehicle.vue?vue&type=script&lang=js&"
export * from "./SeyirLocationLogsForVehicle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports